var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 8,
    viewBox: "0 0 11 8",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.72505 0.098762C8.00527 0.28202 8.08381 0.657264 7.90055 0.937485L3.77966 7.24003C3.73165 7.31346 3.66826 7.37559 3.59388 7.42213C3.5195 7.46867 3.4359 7.4985 3.34887 7.50956C3.26183 7.52062 3.17343 7.51266 3.08977 7.48621C3.00611 7.45976 2.9292 7.41547 2.86434 7.35638L0.197879 4.93233C0.0789424 4.82419 0.00783412 4.67324 0.000196865 4.51267C-0.00744039 4.35211 0.049019 4.19509 0.157155 4.07615C0.26529 3.95721 0.416244 3.88611 0.576808 3.87847C0.737373 3.87083 0.894394 3.92729 1.01333 4.03543L3.15426 5.98146L6.88633 0.274264C6.9743 0.139791 7.11207 0.0457604 7.26935 0.0128491C7.42664 -0.0200621 7.59055 0.0108406 7.72505 0.098762Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7253 0.098762C11.0055 0.28202 11.0841 0.657264 10.9008 0.937485L6.77994 7.24003C6.73192 7.31346 6.66854 7.37559 6.59416 7.42213C6.51978 7.46867 6.43618 7.4985 6.34914 7.50956C6.26211 7.52062 6.17371 7.51266 6.09005 7.48621C6.00639 7.45976 5.92948 7.41547 5.86462 7.35638L5.49951 7L6.15453 5.98146L9.88661 0.274264C9.97457 0.139791 10.1123 0.0457604 10.2696 0.0128491C10.4269 -0.0200621 10.5908 0.0108406 10.7253 0.098762Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRead);
export default __webpack_public_path__ + "static/media/read.a470ad9603d39167786dd7b2d23ee129.svg";
export { ForwardRef as ReactComponent };